import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import { TypeAnimation } from "react-type-animation";
import welcomeAnim from "../assets/welcome-animation.json"; // your downloaded Lottie file

function Welcome({ onFinish }) {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHide(true);
      onFinish();
    }, 4000); // show for 4 seconds
    return () => clearTimeout(timer);
  }, [onFinish]);

  if (hide) return null;

  return (
    <motion.div
      className="fixed inset-0 z-50 bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0f172a] flex flex-col items-center justify-center text-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {/* Lottie Animation */}
      <div className="w-56 md:w-72 mb-6">
        <Lottie animationData={welcomeAnim} loop={true} />
      </div>

      {/* Typing Heading */}
      <TypeAnimation
        sequence={[
          500,
          "WELCOME TO THE PORTFOLIO OF KARMADEEPSINH GOHIL",
          1000,
        ]}
        wrapper="h1"
        cursor={true}
        speed={50}
        className="text-2xl md:text-4xl font-bold text-yellow-300 px-6 text-center"
        repeat={0}
      />

      {/* Glowing line or loading dots */}
      <div className="mt-4 text-sm text-gray-300 animate-bounce">
        Preparing Awesomeness...
      </div>
    </motion.div>
  );
}

export default Welcome;
